"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseError = void 0;
const errors_1 = require("./errors");
/** Try to parse an error type from stderr. */
const parseError = (stderr) => Object.entries(errors_1.GitErrorRegexes).find(([re]) => stderr.match(re))?.[1] ?? null;
exports.parseError = parseError;
//# sourceMappingURL=parse-error.js.map